import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@lockton-apps/material';
import { UiModule } from '@lockton-apps/shared/ui/lui';
import { DynamicTableColumnTemplate } from '../column-template.directive';
import { GetPipe } from '@lockton-apps/shared/util/ng-lodash';

interface SimpleSummaryProps {
  titlePath: string;
  subtitlePath: string;
  iconPath: string;
  sizePath?: string;
  colorPath?: string;
}

@Component({
  selector: 'la-simple-summary-cell',
  imports: [CommonModule, MaterialModule, UiModule, GetPipe],
  templateUrl: './simple-summary-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleSummaryCellComponent extends DynamicTableColumnTemplate<SimpleSummaryProps> {}
